import { useTranslation } from 'react-i18next';

import { resolveSwitchInReviewFileNameKey } from '@features/campaigns/builder/components/CreativePreview/resolveSwitchInReviewFileNameKey.ts';
import { SwitchInCreativePreview } from '@features/campaigns/builder/components/CreativePreview/SwitchInCreativePreview.tsx';
import { CREATIVE_CATEGORY } from '@features/campaigns/builder/types/creativeType.ts';
import { NoCreatives } from '@features/campaigns/shared/components/Review/NoImages/NoImages';
import { AdProductsLShapeLandingCreatives } from '@features/campaigns/shared/containers/Review/AdProducts/components/AdProductsDisplayCreatives/AdProductsLShapeLandingCreatives.tsx';
import { CreativesUploadReminder } from '@features/campaigns/shared/containers/Review/AdProducts/components/AdProductsDisplayCreatives/CreativesUploadReminder.tsx';
import { AdProductsReviewDisplayCreativesVisibility } from '@features/campaigns/shared/containers/Review/AdProducts/getAdProductsReviewVisibility.ts';
import { AdProductsData } from '@features/campaigns/shared/containers/Review/Review.dto';
import { i18nNameSpace } from '@shared/consts/i18n.ts';
import { CampaignId } from '@shared/types/campaign.ts';

interface AdProductsDisplayCreativesProps {
  data: AdProductsData;
  visibility: AdProductsReviewDisplayCreativesVisibility;
  campaignId?: CampaignId;
}

export function AdProductsDisplayCreatives({ data, visibility, campaignId }: AdProductsDisplayCreativesProps) {
  const { t } = useTranslation(i18nNameSpace.CAMPAIGNS);

  return (
    <>
      <div className='row'>
        <div className='col-12'>
          <p className={'subheader'}>{t(visibility.uploadedCreativesLabelKey)}</p>
        </div>
      </div>
      {visibility.isImageUploaded ? (
        <div className='row'>
          {visibility.isSwitchInCreativeAvailable ? (
            <div className={'col-6'}>
              <SwitchInCreativePreview
                leftCreativeUrl={data.switchInLeftImageUrl}
                bottomCreativeUrl={data.switchInBottomImageUrl}
                fileName={resolveSwitchInReviewFileNameKey(data.switchInLeftImageUrl, data.switchInBottomImageUrl)}
                headerText={t('builder.formFields.creativeSwitchInLeftImage.modalHeaderText')}
              />
            </div>
          ) : (
            <AdProductsLShapeLandingCreatives
              lShapeImageUrl={data.lShapeImageUrl}
              landingImageUrl={data.landingImageUrl}
            />
          )}
        </div>
      ) : (
        <div className='row'>
          <div className='col-12'>
            <NoCreatives creativeCategory={CREATIVE_CATEGORY.IMAGE} />
          </div>
        </div>
      )}
      {visibility.shouldShowUploadReminder && (
        <CreativesUploadReminder
          campaignId={campaignId}
          notEnoughCreativesInfoTranslationKey={visibility.notEnoughCreativesInfoTranslationKey}
        />
      )}
    </>
  );
}
